import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import { Warning, WhatsApp } from "@material-ui/icons"
import Link from "@material-ui/core/Link"
import Typography from "../../components/Typography"
import { Grid } from "@material-ui/core"

const styles = (theme) => ({
  resultIcon: {
    fontSize: 96,
    color: theme.palette.secondary.main,
  },
  icon: {
    width: 48,
    height: 48,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.primary.light,
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: theme.palette.common.white,
    },
  },
  marginBottom4: {
    marginBottom: theme.spacing(4),
  },
  contact: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.success.main,
  },
})

const mobileText =
  "https://wa.me/50246789608?text=%C2%A1Hola!%20Luego%20de%20realizar%20la%20encuesta%20de%20COVID-19%20en%20el%20sitio%20de%20BioHealth%2C%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20para%20agendar%20una%20toma%20de%20muestra%20a%20domicilio.%20Gracias."
const desktopText =
  "https://web.whatsapp.com/send?phone=50246789608&text=%C2%A1Hola%21+Luego+de+realizar+la+encuesta+de+COVID-19+en+el+sitio+de+BioHealth%2C+quisiera+m%C3%A1s+informaci%C3%B3n+para+agendar+una+toma+de+muestra+a+domicilio.+Gracias."

function PossibleResult({ classes, isMobile }) {
  return (
    <Grid container>
      <Grid container item justify="center" className={classes.resultIcon}>
        <Warning fontSize="inherit" color="inherit" />
      </Grid>

      <Grid container item justify="center">
        <Typography variant="h6" className={classes.marginBottom4}>
          Eres caso sospechoso.
        </Typography>
      </Grid>

      <Grid container item justify="center">
        <Typography
          variant="subtitle1"
          align="center"
          className={classes.marginBottom4}
        >
          Recomendamos realizarte una prueba de laboratorio de COVID-19.
        </Typography>
      </Grid>

      <Grid container item justify="center">
        <Typography variant="subtitle1" align="center">
          BioHealth te ofrece la toma de muestra a domicilio.
        </Typography>
      </Grid>

      <Grid container item justify="center">
        <Link target="_blank" href={isMobile ? mobileText : desktopText}>
          <Typography variant="h6" className={classes.contact}>
            <WhatsApp color="inherit" />
            &nbsp;Haz click aquí&nbsp;
          </Typography>
        </Link>
        <Typography variant="subtitle1">o contáctanos al 4678-9608</Typography>
      </Grid>
    </Grid>
  )
}

PossibleResult.propTypes = {
  isMobile: PropTypes.bool,
}

export default withStyles(styles)(PossibleResult)
